import { Stack } from '@mantine/core';
import { useRef } from 'react';
import { MainSectionContent } from './main-section-content';
import { MainSectionHeader } from './main-section-header';

export const MainSection = () => {
  const chartRef = useRef<HTMLDivElement | null>(null);

  return (
    <Stack h="100%" style={{ overflow: 'hidden' }}>
      <MainSectionHeader chartRef={chartRef} />
      <MainSectionContent chartRef={chartRef} />
    </Stack>
  );
};
